import React from "react";

export const ColumnFilter = ({ column }: any) => {
  const { filterValue, setFilter } = column;
  return (
    <input
      value={filterValue || ""}
      className="w-24 h-8 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200 text-sm px-3"
      onChange={(e) => setFilter(e.target.value)}
      placeholder="Filter..."
    />
  );
};
